import {
  OR_TOGGLE_CANCEL_ORDER_MODAL,
  OR_REQUEST_ORDER_CANCEL,
  OR_ORDER_CANCEL_SUCCESS,
  OR_ORDER_CANCEL_ERROR,
} from '../../actions/management/cancelOrder';

export const initialState = {
  isCancellingOrder: false,
  isCancellingOrderError: false,
  isCancelModalVisible: false,
  orderToCancelNumber: null,
};

export default function cancelOrderDataReducer(state = initialState, action) {
  switch (action.type) {
    case OR_TOGGLE_CANCEL_ORDER_MODAL:
      return {
        ...state,
        isCancelModalVisible: !state.isCancelModalVisible,
        orderToCancelNumber: action.orderNumber || null,
        isCancellingOrderError: false,
      };
    case OR_REQUEST_ORDER_CANCEL:
      return { ...state, isCancellingOrder: true };
    case OR_ORDER_CANCEL_SUCCESS:
      return {
        ...state,
        isCancellingOrder: false,
        isCancellingOrderError: false,
        isCancelModalVisible: false,
        orderToCancelNumber: null,
      };
    case OR_ORDER_CANCEL_ERROR:
      return { ...state, isCancellingOrder: false, isCancellingOrderError: true };
    default:
      return state;
  }
}
